import { render, staticRenderFns } from "./MainNavigationDesktopItems.vue?vue&type=template&id=0796460e&scoped=true"
import script from "./MainNavigationDesktopItems.vue?vue&type=script&lang=js"
export * from "./MainNavigationDesktopItems.vue?vue&type=script&lang=js"
import style0 from "./MainNavigationDesktopItems.vue?vue&type=style&index=0&id=0796460e&prod&lang=css"
import style1 from "./MainNavigationDesktopItems.vue?vue&type=style&index=1&id=0796460e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796460e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChevronRightIcon: require('/vercel/path0/components/icons/ChevronRightIcon.vue').default,AppLink: require('/vercel/path0/components/shared/AppLink.vue').default})
